// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3iybF","alertIcon":"ConfirmModal_alertIcon__2Ino3"};